import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';

export default function AffiliatedControl({ affiliatedMode, setAffiliatedMode }) {
  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">Affiliated Teams Handling</FormLabel>
      <RadioGroup
        row
        aria-label="affiliated-mode"
        name="affiliated-mode"
        value={affiliatedMode}
        onChange={(e) => setAffiliatedMode(e.target.value)}
      >
        <FormControlLabel value="none" control={<Radio />} label="Do nothing" />
        <FormControlLabel value="average" control={<Radio />} label="Average (if below avg)" />
        <FormControlLabel value="max" control={<Radio />} label="Max (use worst score)" />
        <FormControlLabel value="exclude" control={<Radio />} label="Affiliated Exclude (set to 1500)" />
        <FormControlLabel value="up_next" control={<Radio />} label="Up Next (next non-affiliated score)" />
      </RadioGroup>
    </FormControl>
  );
}
